import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApplicationPackage } from 'src/app/enums/application-package.enum';
import { Service } from 'src/app/enums/service.enum';
import { ResponseObj } from 'src/app/main/responseObj';
import { Observable } from 'rxjs';
import { CustomHttpUrlEncodingCodec } from 'src/app/main/encoder';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  protected baseUrl: string = environment.endPoint + ApplicationPackage.AUTH_OP + Service.OPERATIONAL + '/opusers/sessions';

  constructor(
    private http: HttpClient
  ) { }


  listActiveSessions(): Observable<ResponseObj> {
    return this.http.get(this.baseUrl);
  }

  terminateSession(userID: number): Observable<ResponseObj> {
    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (userID !== undefined && userID !== null) {
      queryParameters = queryParameters.set('userId', <any>userID);
    }
    return this.http.delete(this.baseUrl + '/terminate', {params: queryParameters});
  }

  listSessionHistories(userID?: any, beginDate?: any, endDate?: any): Observable<ResponseObj> {
    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (userID !== undefined && userID !== null) {
      queryParameters = queryParameters.set('userId', <any>userID);
    }

    if (beginDate !== undefined && beginDate !== null) {
      queryParameters = queryParameters.set('begindate', <any>beginDate);
    }

    if (endDate !== undefined && endDate !== null) {
      queryParameters = queryParameters.set('enddate', <any>endDate);
    }

    return this.http.get(this.baseUrl + '/history', {params: queryParameters});
  }

  getActiveSessionsCount(): Observable<ResponseObj> {
    return this.http.get(this.baseUrl + '/count');
  }


}
